export default __webpack_public_path__ + "static/media/settings.22231209.svg";